/**
 * GoalModal — веб-версия по образцу mobile
 * Обёртка над AddGoalFlow/EditGoalFlow с интерфейсом как в mobile
 */

import React from 'react';
import { AddGoalFlow, type GoalData } from './AddGoalFlow';
import { EditGoalFlow, type EditGoalData } from './EditGoalFlow';
import type { Goal } from '@alveon/shared';

interface GoalModalProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (goal: Partial<Goal>) => Promise<void>;
  goal?: Goal | null;
  currency?: string;
}

export function GoalModal({
  visible,
  onClose,
  onSubmit,
  goal,
  currency = 'RUB',
}: GoalModalProps) {
  const handleAddSubmit = async (data: GoalData) => {
    await onSubmit({
      name: data.name,
      icon: data.icon,
      target_amount: data.type === 'piggybank' ? null : data.target_amount ?? undefined,
    });
  };

  const handleEditSubmit = async (goalId: string, data: EditGoalData) => {
    await onSubmit({
      id: goalId,
      name: data.name,
      icon: data.icon,
      target_amount: data.type === 'piggybank' ? null : data.target_amount ?? undefined,
    });
  };

  if (!visible) return null;

  if (goal) {
    return (
      <EditGoalFlow
        goalId={goal.id}
        initialData={{
          name: goal.name,
          icon: goal.icon,
          target_amount: goal.target_amount ?? undefined,
        }}
        onClose={onClose}
        onSubmit={handleEditSubmit}
        currency={currency}
        currencyCode={currency}
      />
    );
  }

  return (
    <AddGoalFlow
      onClose={onClose}
      onSubmit={handleAddSubmit}
      currency={currency}
      currencyCode={currency}
    />
  );
}
